<!-- <button mat-mdc-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="close-button" [mat-dialog-close]><mat-icon>close</mat-icon></button> -->
<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="close-button" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<h2 mat-mdc-dialog-title>{{ 'T4.Service.ServiceGuyDialog.lblUpdateStock' | translate : 'Update stock'}}</h2>

<t4-container>
  <mat-dialog-content>
    <t4-data-table #tblInStock [allowFilter]="false" [allowPaging]="false" [allowExcel]="false" [rawData]="items" headline="{{'T4.Service.ServiceGuyDialog.lblserviceguyupdatestock' | translate : 'Update Stock' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['ItemId', 'Name']">
      <ng-container matColumnDef="ItemId">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Service.ServiceGuyInStockDialogItemId' |translate : 'Item Id' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.ItemId}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Service.ServiceGuyDialogItemName' |translate : 'Item Name' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.Name}}<ng-container></ng-container></mat-cell>
      </ng-container>

      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Service.ServiceGuyDialogItemAmount' |translate : 'Amount' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">

          <mat-form-field appearance="outline">

            <input matInput
                   id="txtamount"
                   autocomplete="off"
                   type="number"
                   [(ngModel)]="row.OrderAmount"/>
          </mat-form-field>

        </mat-cell>
      </ng-container>

    </t4-data-table>

  </mat-dialog-content>
</t4-container>
<mat-dialog-actions>
  <div class="col-6" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()">
      {{'T4.Service.ServiceGuyDialog.cmdConfirm' | translate : 'Save' }}
    </button>
  </div>
</mat-dialog-actions>
